/**
 * Accès storage tolérant aux environnements où le storage est interdit
 * (iframe sandbox, Mobile Safari third-party, WebView…) → sinon SecurityError.
 */

export function safeLocalStorageGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeLocalStorageSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage indisponible — session en mémoire uniquement.
  }
}

export function safeLocalStorageRemoveItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // noop
  }
}

export function safeSessionStorageGetItem(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSessionStorageSetItem(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // noop
  }
}

export function safeSessionStorageRemoveItem(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // noop
  }
}

/** Token JWT client — lecture safe (utiliser partout au render / interceptors). */
export function getAuthToken(): string | null {
  return safeLocalStorageGetItem('token');
}
